const isNode = typeof window === 'undefined';
// Accessing localStorage itself can throw in embedded or privacy-restricted browsers.
const storage = (() => {
	if (isNode) return null;
	try { return window.localStorage; } catch { return null; }
})();

const toSnakeCase = (str) => {
	return str.replace(/([A-Z])/g, '_$1').toLowerCase();
}

const getAppParamValue = (paramName, { defaultValue = undefined, removeFromUrl = false } = {}) => {
	if (isNode) {
		return defaultValue;
	}
	const storageKey = `base44_${toSnakeCase(paramName)}`;
	const urlParams = new URLSearchParams(window.location.search);
	const searchParam = urlParams.get(paramName);
	if (removeFromUrl) {
		urlParams.delete(paramName);
		const newUrl = `${window.location.pathname}${urlParams.toString() ? `?${urlParams.toString()}` : ""
			}${window.location.hash}`;
		window.history.replaceState({}, document.title, newUrl);
	}
	if (searchParam) {
		try { storage.setItem(storageKey, searchParam); } catch {}
		return searchParam;
	}
	if (defaultValue) {
		try { storage.setItem(storageKey, defaultValue); } catch {}
		return defaultValue;
	}
	let storedValue = null;
	try { storedValue = storage?.getItem(storageKey); } catch { /* Storage may be blocked. URL parameters remain usable. */ }
	if (storedValue) {
		return storedValue;
	}
	return null;
}

const getAppParams = () => {
	return {
		appId: getAppParamValue("app_id", { defaultValue: import.meta.env.VITE_BASE44_APP_ID }),
		serverUrl: getAppParamValue("server_url", { defaultValue: import.meta.env.VITE_BASE44_BACKEND_URL }),
		token: getAppParamValue("access_token", { removeFromUrl: true }),
		fromUrl: getAppParamValue("from_url", { defaultValue: window.location.href }),
		functionsVersion: getAppParamValue("functions_version"),
	}
}


let _params;
try {
	_params = getAppParams();
} catch {
	_params = {
		appId: import.meta.env.VITE_BASE44_APP_ID,
		serverUrl: import.meta.env.VITE_BASE44_BACKEND_URL,
		token: null,
		fromUrl: typeof window !== 'undefined' ? window.location.href : '',
		functionsVersion: null,
	};
}
export const appParams = { ..._params };